import React, { useState } from "react";
import { MdWaterDrop } from "react-icons/md";
import { HiLocationMarker, HiOutlineViewGridAdd } from "react-icons/hi";
import { GiScubaTanks } from "react-icons/gi";
import { FaSyringe } from "react-icons/fa";
import style from "./Ongoing.module.scss";
import styled from "./Modal.module.scss";
import Button from "@mui/material/Button";
import { ConfirmationModal } from "../../Modal/ConfirmationModal";
import { SuccessModal } from "../../Modal/SuccessModal";
import MessageInstruction from "../../modalInstruction/MessageInstruction";
import { constructOrderDate } from "../../../helper/DateFormatter";
import { useDispatch, useSelector } from "react-redux";
import {
  ongoingOrders,
  processOrder,
  trackOrder,
} from "../../../redux/orders/actions/orders.actions";
import { useNavigate } from "react-router-dom";

import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import {
  EditOutlined,
  IssuesCloseOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import UpdateForm from "../../modalInstruction/UpdateForm";
import { editComponent, editType } from "../../../data";
import Card from "../../paymentCard/Card";
import { FiSettings } from "react-icons/fi";
import CancelForm from "../../modalInstruction/CancelForm";
import ClosePaymentDetails from "../../modalInstruction/closePaymentDetails";
import Override from "../../modalInstruction/Override";

const Ongoing = ({
  order_id,
  id,
  component,
  name,
  product,
  address,
  city,
  state,
  tym,
  order_by,
  qty,
  title,
  dispatch_name,
  vendor_name,
  payment_type,
  vendor_accepted,
  vendor_override,
}) => {
  const [cancelModal, setCancelModal] = useState(false);
  const [closeModal, setCloseModal] = useState(false);
  const [closeUpdateModal, setCloseUpdateModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [updateType, setUpdateType] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [override, setOverride] = useState(false);
  const [selectedOverride, setSelectedOverride] = useState(null);
  // console.log("selectedOverride", selectedOverride);

  const handleOverride = (details) => {
    setSelectedOverride(details);
    setOverride(true);
  };

  const navigate = useNavigate();

  const { closed } = useSelector((state) => state.orderReducer);

  let userDetails;
  if (localStorage.getItem("userToken")) {
    userDetails = JSON.parse(localStorage.getItem("userToken"));
  }

  const badgeColor = () => {
    if (title === "blood") return "#FDE0E0";
    if (title === "oxygen") return "#E0EFFD";
    if (title === "Quip") return "#ffd4c2";
    return "#F0FDE0";
  };

  const icons = () => {
    if (title === "blood") return <MdWaterDrop size={25} color="#B70303" />;
    if (title === "oxygen") return <GiScubaTanks size={25} color="#2457C5" />;
    if (title === "Quip") return <FiSettings size={25} color="#c7460f" />;
    return <FaSyringe size={25} color="#78A55A" />;
  };

  const colors = () => {
    if (title === "blood") return "#B70303";
    if (title === "oxygen") return "#2457C5";
    if (title === "Quip") return "#c7460f";
    return "#78A55A";
  };

  const dispatcher = useDispatch();

  // const [loading] = useState(false);

  const handleUpdate = () => {
    setCancelModal(false);
    setCloseModal(true);
  };

  const handleCloseUpdate = () => {
    setUpdateModal(false);
    setCloseUpdateModal(true);
  };

  const exitModal = () => {
    setCloseModal(false);
    setCloseUpdateModal(false);
    dispatcher(ongoingOrders());
  };

  const trackHandler = (id) => {
    dispatcher(trackOrder(id, { title: title === "blood" ? "Blood" : title }));
    navigate(`/track-order/${order_id}`);
  };

  const delay = (ms) => {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  };

  const data = {
    title: title === "blood" ? "Blood" : title,
    order_by: order_by,
    bloodtype: product,
  };

  // update function
  const updateTypeFunc = async () => {
    dispatcher(processOrder(data));
    setLoading(true);
    await delay(3000);
    setLoading(false);
    setUpdateType(true);
  };

  const editHandler = (type) => {
    window.localStorage.setItem("editType", type?.label);
    setUpdateType(false);
    setUpdateModal(true);
  };

  let selectedType;

  if (window.localStorage.getItem("editType"))
    selectedType = window.localStorage.getItem("editType");

  const handleClose = () => {
    // setLoading(true);
    // if (title === "oxygen") {
    //   dispatcher(
    //     closeOrder({
    //       title: title === "blood" ? "Blood" : title,
    //       order_id: order_id,
    //     })
    //   );
    // } else {
    //   dispatcher(
    //     closeOrder({
    //       title:
    //         title === "blood"
    //           ? "Blood"
    //           : title === "StockBank"
    //           ? "stockbank"
    //           : title,
    //       order_id: order_id,
    //     })
    //   );
    // }

    setLoading(false);
    setPaymentModal(false);
    setCloseModal(true);
    // return;
  };

  return (
    <>
      <div>
        <div className={style.container}>
          <div className={style.innerContainer}>
            <div className={style.content}>
              <div
                className={`${style.icon}`}
                style={{ background: badgeColor() }}
              >
                {icons()}
              </div>
              <div className="d-flex flex-column">
                <p className={style.header}>Product Name</p>
                <p className={style.text}>{product}</p>
              </div>
            </div>

            <div className={style.content}>
              <div className={style.icon} style={{ background: badgeColor() }}>
                <HiOutlineViewGridAdd size={25} color={colors()} />
              </div>
              <div className="d-flex flex-column">
                <p className={style.header}>QUANTITY</p>
                <p className={style.text}>{qty}</p>
              </div>
            </div>
             <div className={style.content}>
              <div className="d-flex flex-column">
                <p className={style.header}>ORDER ID</p>
                <p className={style.text}>{order_id}</p>
              </div>
            </div>
            <div className={style.content}>
              <div className="d-flex flex-column">
                <p className={style.header}>VENDOR NAME</p>
                <p className={style.text}>{vendor_name}</p>
              </div>
            </div>
            <div className={style.content}>
              <div className="d-flex flex-column">
                <p className={style.header}>HOSPITAL NAME</p>
                <p className={style.text}>{name}</p>
              </div>
            </div>
            <div className={`${style.content} ${style.address}`}>
              <div className={style.icon} style={{ background: badgeColor() }}>
                <HiLocationMarker size={25} color={colors()} />
              </div>
              <div className="d-flex flex-column">
                <p className={style.header}>HOSPITAL ADDRESS</p>
                <p
                  className={style.text2}
                >{` ${address}, ${city}, ${state}`}</p>
              </div>
            </div>
            <div className={style.content}>
              <div className="d-flex flex-column align-items-center justify-content-center">
                <Button
                  className={style.button}
                  style={{
                    border: `2px solid ${badgeColor()}`,
                    color: colors(),
                  }}
                  onClick={() => setPaymentModal(true)}
                  disabled={loading}
                >
                  close
                </Button>
                <Button
                  className={style.button}
                  style={{
                    border: `2px solid ${badgeColor()}`,
                    color: colors(),
                  }}
                  onClick={() => setCancelModal(true)}
                  disabled={loading}
                >
                  cancel
                </Button>
                <Button
                  className={style.button}
                  style={{
                    border: `2px solid ${badgeColor()}`,
                    color: colors(),
                  }}
                  onClick={() => trackHandler(order_id)}
                  disabled={loading}
                >
                  track
                </Button>

                {vendor_accepted === "" || vendor_override === null ? (
                  <Button
                  className={style.button}
                  style={{
                    border: `2px solid ${badgeColor()}`,
                    color: colors(),
                  }}
                  onClick={() => handleOverride({order_id, title})}
                  disabled={loading}
                >
                  override
                </Button>
                ) : (
                  ""
                )}
                
              </div>
            </div>
          </div>
          <div className={style.bott}>
            <div className={style.time}>
              Last update :{constructOrderDate(tym)}
            </div>

            <div className={style.update} onClick={updateTypeFunc}>
              {loading ? <SyncOutlined spin /> : "Update Order"}
            </div>
          </div>
        </div>

        {/* update Modal */}
        <ConfirmationModal
          open={updateType}
          handleClose={() => setUpdateType(false)}
          closemodal={() => setUpdateType(false)}
          bgcolor=" rgba(255, 255, 255, 0.92)"
          width="50%"
          instruction={
            <div>
              <h3 className={style.header2} style={{ color: colors() }}>
                What would you like to update?
              </h3>
              {title === "blood" ? (
                <div className={style.cards}>
                  {editComponent.map((type) => (
                    <Card
                      {...type}
                      key={type.id}
                      onClick={() => editHandler(type)}
                    />
                  ))}
                </div>
              ) : (
                <div className={style.cards}>
                  {editType.map((type) => (
                    <Card
                      {...type}
                      key={type.id}
                      onClick={() => editHandler(type)}
                    />
                  ))}
                </div>
              )}
            </div>
            // </div>
          }
        />

        {/* close details MODAL */}
        <ConfirmationModal
          open={paymentModal}
          handleClose={() => setPaymentModal(false)}
          closemodal={() => setPaymentModal(false)}
          bgcolor=" rgba(255, 255, 255, 0.92)"
          width="55vw"
          instruction={
            <div className="d-flex flex-column justify-content-center">
              <div className="d-flex justify-content-between mt-3 mb-3">
                <p className={styled.breadcumb} style={{ color: colors() }}>
                  <IssuesCloseOutlined
                    style={{ fontSize: "35px" }}
                    className="me-3"
                  />
                  <span>CLOSE ORDER</span>{" "}
                </p>
              </div>
              <div className="d-flex flex-column justify-content-center align-items-center">
                <ClosePaymentDetails
                  name={name}
                  qty={qty}
                  product={product}
                  title={title}
                  order_id={order_id}
                  payment={payment_type}
                  colors={colors()}
                  // id={title === "blood" ? order_id : id}
                  // title={title === "blood" ? "Blood" : title}
                  order_by={order_by}
                  agent={userDetails?.id}
                  onClickNo={() => setPaymentModal(false)}
                  onClickYes={() => handleClose()}
                />
              </div>
            </div>
          }
        />

        {/* override modal */}

        <Override
          override={override}
          setOverride={setOverride}
          selectedOverride={selectedOverride}
        />

        {/* UPDATE MODAL */}
        <ConfirmationModal
          open={updateModal}
          handleClose={() => setUpdateModal(false)}
          closemodal={() => setUpdateModal(false)}
          bgcolor=" rgba(255, 255, 255, 0.92)"
          width="40vw"
          instruction={
            <div className="d-flex flex-column justify-content-center">
              <div className="d-flex justify-content-between mt-3 mb-3">
                <p className={styled.breadcumb} style={{ color: colors() }}>
                  <EditOutlined style={{ fontSize: "35px" }} className="me-3" />
                  <span>
                    {selectedType === "DISPATCH"
                      ? "UPDATE DISPATCH RIDER"
                      : selectedType === "PAYMENT"
                      ? "UPDATE PAYMENT MODE"
                      : selectedType === "COMPONENT"
                      ? "UPDATE COMPONENT"
                      : selectedType === "QUANTITY"
                      ? "UPDATE QUANTITY"
                      : "UPDATE VENDOR"}
                  </span>{" "}
                </p>
              </div>
              <div className="d-flex flex-column justify-content-center align-items-center">
                <UpdateForm
                  name={name}
                  qty={qty}
                  product={product}
                  title={title}
                  bloodComponent={component}
                  order_id={order_id}
                  dispatch={dispatch_name}
                  vendor={vendor_name}
                  b_type={product}
                  payment={payment_type}
                  order_by={order_by}
                  agent={userDetails?.id}
                  onClickNo={() => setUpdateModal(false)}
                  onClickYes={() => handleCloseUpdate()}
                />
              </div>
            </div>
          }
        />

        {/* Close MODAL */}
        <SuccessModal
          open={closeModal}
          onClose={() => setCloseModal(false)}
          bgcolor={colors()}
          width="50vw"
          height="35vh"
          instruction={
            <MessageInstruction
              heading={"ORDER CANCELLED SUCCESSFULLY!!"}
              content={` It took this order ${closed?.time} Hours to be closed`}
              button="OKAY"
              onClickBtn={exitModal}
              color={badgeColor()}
            />
          }
        />

        {/* update success MODAL */}
        <SuccessModal
          open={closeUpdateModal}
          onClose={() => setCloseUpdateModal(false)}
          bgcolor={colors()}
          width="50vw"
          height="35vh"
          instruction={
            <MessageInstruction
              heading={"ORDER UPDATED SUCCESSFULLY!!"}
              // content={` It took this order ${closed?.time} Hours to be closed`}
              button="OKAY"
              onClickBtn={exitModal}
              color={badgeColor()}
            />
          }
        />

        {/* cancel order MODAL */}
        <ConfirmationModal
          open={cancelModal}
          handleClose={() => setCancelModal(false)}
          closemodal={() => setCancelModal(false)}
          bgcolor=" rgba(255, 255, 255, 0.92)"
          width="45vw"
          instruction={
            <div className="d-flex flex-column justify-content-center">
              <div className="d-flex justify-content-between mt-3 mb-3">
                <p className={styled.breadcumb} style={{ color: colors() }}>
                  <IssuesCloseOutlined
                    style={{ fontSize: "35px" }}
                    className="me-3"
                  />
                  <span>CANCEL ORDER</span>{" "}
                </p>
              </div>
              <div className="d-flex flex-column justify-content-center align-items-center">
                <CancelForm
                  title={title}
                  order_id={order_id}
                  onClickNo={() => setCancelModal(false)}
                  onClickYes={() => handleUpdate()}
                />
              </div>
            </div>
          }
        />
      </div>
    </>
  );
};

export default Ongoing;
